import { Fragment, useState } from "react";
import { Button, Collapse, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import PaymentReportCell from "./PaymentReportCell";

/** Column titles, visibility and order come exclusively from the report API's database metadata. */
export default function PaymentReportTable({ headers, extraHeaders = [], rows, busyId, refresh }) {
  const [expanded, setExpanded] = useState(null);
  return <TableContainer sx={{ maxHeight: "65vh" }}>
    <Table stickyHeader size="small" sx={{ minWidth: 760 }} aria-label="پرداخت‌های درگاه">
      <TableHead><TableRow>{headers.map((column) => <TableCell key={column.name} colSpan={column.colSpan}>{column.title}</TableCell>)}{extraHeaders.length > 0 && <TableCell>جزئیات</TableCell>}</TableRow></TableHead>
      <TableBody>{rows.map((row) => <Fragment key={row.id}><TableRow hover>
        {headers.map((column) => <TableCell key={column.name} colSpan={column.colSpan}
          sx={["amountMinor", "refundedAmountMinor", "createdAt", "updatedAt"].includes(column.name) ? { whiteSpace: "nowrap" } : undefined}>
          <PaymentReportCell name={column.name} row={row} busyId={busyId} refresh={refresh} />
        </TableCell>)}
        {extraHeaders.length > 0 && <TableCell><Button size="small" aria-expanded={expanded === row.id} onClick={() => setExpanded(expanded === row.id ? null : row.id)}>جزئیات</Button></TableCell>}
      </TableRow>{extraHeaders.length > 0 && <TableRow><TableCell colSpan={headers.reduce((sum, column) => sum + column.colSpan, 1)} sx={{ p: 0, border: 0 }}>
        <Collapse in={expanded === row.id} unmountOnExit><dl className="grid gap-3 p-4 sm:grid-cols-2">
          {extraHeaders.map((column) => <div key={column.name}><dt className="mb-1 font-bold">{column.title}</dt><dd className="m-0"><PaymentReportCell name={column.name} row={row} busyId={busyId} refresh={refresh} /></dd></div>)}
        </dl></Collapse>
      </TableCell></TableRow>}</Fragment>)}</TableBody>
    </Table>
  </TableContainer>;
}
